#import "../LookupCorporateAccountFields.graphql"

query LookupCorporateAccountSearch(
  $chartOfAccountId: UUID!
  $lookupName: String!
  $orderBy: [LookupCorporateAccountsOrderBy!]
  $first: Int
  $after: Cursor
) {
  lookupCorporateAccountSearch(
    chartOfAccountId: $chartOfAccountId
    lookupName: $lookupName
    orderBy: $orderBy
    first: $first
    after: $after
  ) {
    nodes {
      ...LookupCorporateAccountFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
